// Minimum length for any flow that SETS a password (change, reset, admin
// create-user). Keep in sync with the API's MIN_PASSWORD_LENGTH
// (api/src/constants/auth.js).
export const MIN_PASSWORD_LENGTH = 8;
